import * as correspondentListAction from './action';
const initialState = {
    taskData: []
}
const correspondentListReducer = (state = initialState, action) => {
    switch (action.type) {
        case correspondentListAction.VIEW_ALL_TASKS_SUCCESS:
            return state = {
                ...state,
                taskData: action.data
            }
        case correspondentListAction.VIEW_ALL_TASKS_FAILURE:
            return state = {
                ...state,
                taskData: action.error
            }
        default: return state
    }
}

export default correspondentListReducer; 